import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteModule } from 'src/app/shared/autocomplete/autocomplete.module';
import { DatepickerInputModule } from 'src/app/shared/components/datepicker-input/datepicker-input.module';
import { DialogModule } from 'src/app/shared/components/dialog/dialog.module';
import { FileAttachmentModule } from 'src/app/shared/components/file-attachment/file-attachment.module';
import { GenericWriteTableModule } from 'src/app/shared/components/generic-write-table/genetic-write-table.module';
import { InputSearchScannerModule } from 'src/app/shared/components/input-search-scanner/input-search-scanner.module';
import { InputModule } from 'src/app/shared/components/input/input.module';
import { FormattedDateModule } from 'src/app/shared/pipes/formatted-date/formatted-date.module';
import { FormattedDatePipe } from 'src/app/shared/pipes/formatted-date/formatted-date.pipe';
import { TransactionsService } from 'src/app/shared/services/transactions.service';
import { DestroyInventoryDialogComponent } from './destroy-inventory-dialog.component';
import { SupplierBuyerCardModule } from '../../supplier-buyer-sale-details/supplier-buyer-card/supplier-buyer-card.module';



@NgModule({
  declarations: [DestroyInventoryDialogComponent],
  imports: [
    CommonModule,
    DialogModule,
    InputSearchScannerModule,
    FormsModule,
    ReactiveFormsModule,
    GenericWriteTableModule,
    FileAttachmentModule,
    AutocompleteModule,
    InputModule,
    DatepickerInputModule,
    FormattedDateModule,
    SupplierBuyerCardModule
  ],
  exports: [DestroyInventoryDialogComponent],
  providers: [FormattedDatePipe]
})
export class DestroyInventoryDialogModule { }
